export const OPEN_MODAL = "OPEN_MODAL";

export const HIDE_MODAL = "HIDE_MODAL";

export const OPEN_FORM_EDIT_PROJECT = "OPEN_FORM_EDIT_PROJECT";

export const SET_EDIT_SUBMIT_PROJECT = "SET_EDIT_SUBMIT_PROJECT";